import { render, staticRenderFns } from "./OneClickSync.vue?vue&type=template&id=637bab02&scoped=true"
import script from "./OneClickSync.vue?vue&type=script&lang=js"
export * from "./OneClickSync.vue?vue&type=script&lang=js"
import style0 from "./OneClickSync.vue?vue&type=style&index=0&id=637bab02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637bab02",
  null
  
)

export default component.exports